import React, { useState } from 'react';

const faqs = [
  {
    id: 1,
    question: "What is internal audit?",
    answer:
      "Internal audit is an independent, objective assurance and consulting activity designed to add value and improve an organization's operations.",
    topic: "General",
    category: "Definition",
  },
  {
    id: 2,
    question: "Why is internal audit important?",
    answer:
      "Internal audit helps organizations assess and improve risk management, control, and governance processes.",
    topic: "General",
    category: "Benefits",
  },
  {
    id: 3,
    question: "Who performs internal audits?",
    answer:
      "Internal audits are typically performed by an in-house internal audit team or by external professionals who specialize in auditing.",
    topic: "Process",
    category: "Roles",
  },
  {
    id: 4,
    question: "How often are internal audits conducted?",
    answer:
      "The frequency of internal audits varies depending on the organization's size, industry, and regulatory requirements. They are often conducted on an annual or quarterly basis.",
    topic: "Process",
    category: "Frequency",
  },
  {
    id: 5,
    question: "What qualifications are required for internal auditors?",
    answer:
      "Qualifications for internal auditors often include a bachelor's degree in accounting, finance, or related fields, along with certifications such as CIA, CPA, or CISA.",
    topic: "Qualifications",
    category: "Certification",
  },
  {
    id: 6,
    question: "How do internal auditors maintain independence?",
    answer:
      "Internal auditors maintain independence by reporting functionally to the board or audit committee rather than management, ensuring objective evaluations.",
    topic: "Process",
    category: "Governance",
  },
  {
    id: 7,
    question: "What role does technology play in internal auditing?",
    answer:
      "Technology plays a crucial role in internal auditing by enabling data analytics, continuous monitoring, and more efficient audit processes.",
    topic: "Technology",
    category: "Tools",
  },
  {
    id: 8,
    question: "What are the core components of an internal audit framework?",
    answer:
      "The internal audit framework includes risk assessment, planning, fieldwork, reporting, and follow-up procedures that guide the audit process.",
    topic: "Framework",
    category: "Components",
  },
  {
    id: 9,
    question: "How is risk assessed during an internal audit?",
    answer:
      "Risk assessment is conducted by evaluating inherent risks, control effectiveness, and mitigation strategies to prioritize audit areas.",
    topic: "Risk Management",
    category: "Assessment",
  },
  {
    id: 10,
    question: "What are common audit methodologies?",
    answer:
      "Common methodologies include risk-based auditing, compliance auditing, and performance auditing to address different organizational needs.",
    topic: "Methodologies",
    category: "Approaches",
  },
  {
    id: 11,
    question: "How do internal auditors identify control weaknesses?",
    answer:
      "They identify control weaknesses by testing processes, reviewing documentation, and interviewing staff to evaluate the effectiveness of controls.",
    topic: "Process",
    category: "Control",
  },
  {
    id: 12,
    question: "What is the role of internal audit in fraud prevention?",
    answer:
      "Internal audit helps prevent fraud by evaluating internal controls, detecting irregularities, and recommending improvements to minimize fraud risks.",
    topic: "Fraud",
    category: "Prevention",
  },
  {
    id: 13,
    question: "How does internal audit contribute to compliance?",
    answer:
      "It ensures that organizational policies, procedures, and regulatory requirements are followed, reducing the risk of non-compliance.",
    topic: "Compliance",
    category: "Contribution",
  },
  {
    id: 14,
    question: "What is a risk-based audit approach?",
    answer:
      "A risk-based audit approach focuses on areas with higher risk exposure, allowing auditors to allocate resources more effectively.",
    topic: "Risk Management",
    category: "Methodology",
  },
  {
    id: 15,
    question: "How do internal auditors plan an audit?",
    answer:
      "Auditors plan by defining the scope, objectives, resource requirements, and timelines based on a thorough risk assessment.",
    topic: "Audit Planning",
    category: "Process",
  },
  {
    id: 16,
    question: "What are key challenges in internal auditing?",
    answer:
      "Challenges include adapting to evolving regulations, handling complex technology systems, and maintaining auditor independence.",
    topic: "Challenges",
    category: "General",
  },
  {
    id: 17,
    question: "How is audit evidence collected?",
    answer:
      "Audit evidence is gathered through methods such as interviews, observations, document reviews, and data analytics.",
    topic: "Process",
    category: "Evidence",
  },
  {
    id: 18,
    question: "What are the benefits of continuous auditing?",
    answer:
      "Continuous auditing provides real-time insights, early detection of issues, and ongoing monitoring that enhances risk management.",
    topic: "Technology",
    category: "Benefits",
  },
  {
    id: 19,
    question: "How do internal auditors report their findings?",
    answer:
      "Audit findings are reported through detailed reports, presentations, and discussions with management and the audit committee.",
    topic: "Reporting",
    category: "Process",
  },
  {
    id: 20,
    question: "What are the best practices for internal audit reporting?",
    answer:
      "Best practices include clarity in communication, actionable recommendations, and timely reporting to ensure effective follow-up.",
    topic: "Reporting",
    category: "Best Practices",
  },
  {
    id: 21,
    question: "How do external audits differ from internal audits?",
    answer:
      "External audits are conducted by independent firms focusing on financial statements, while internal audits focus on internal controls and operational risk.",
    topic: "Process",
    category: "Differences",
  },
  {
    id: 22,
    question: "What is the importance of audit follow-up?",
    answer:
      "Follow-up is critical to ensure that corrective actions are implemented and that identified issues are resolved effectively.",
    topic: "Audit Follow-up",
    category: "Importance",
  },
  {
    id: 23,
    question: "How do internal auditors handle conflicts of interest?",
    answer:
      "They handle conflicts of interest by adhering to professional ethics, maintaining independence, and ensuring transparent reporting.",
    topic: "Governance",
    category: "Ethics",
  },
  {
    id: 24,
    question: "What are the common tools used in internal auditing?",
    answer:
      "Common tools include audit management software, data analytics platforms, and risk assessment tools that help streamline the process.",
    topic: "Technology",
    category: "Tools",
  },
  {
    id: 25,
    question: "How is the effectiveness of internal audit measured?",
    answer:
      "Effectiveness is measured by the quality of audit reports, timely issue resolution, and improvements in internal controls.",
    topic: "Performance",
    category: "Metrics",
  },
  {
    id: 26,
    question: "What regulatory standards influence internal audit practices?",
    answer:
      "Standards such as the IIA's International Standards for the Professional Practice of Internal Auditing and various local regulations guide audit practices.",
    topic: "Standards",
    category: "Regulations",
  },
  {
    id: 27,
    question: "How does internal audit support corporate governance?",
    answer:
      "Internal audit supports corporate governance by providing independent assessments and ensuring that policies and controls are effectively implemented.",
    topic: "Governance",
    category: "Support",
  },
  {
    id: 28,
    question: "What role does communication play in internal auditing?",
    answer:
      "Effective communication is essential for clearly reporting audit findings and recommendations, building trust with stakeholders.",
    topic: "Communication",
    category: "Process",
  },
  {
    id: 29,
    question: "How do internal auditors stay updated with industry trends?",
    answer:
      "They stay updated through continuous professional development, attending training sessions, and participating in industry forums.",
    topic: "Qualifications",
    category: "Professional Development",
  },
  {
    id: 30,
    question: "What is the future outlook for internal auditing?",
    answer:
      "The future of internal auditing includes increased automation, enhanced data analytics, and a growing emphasis on strategic advisory roles.",
    topic: "Future",
    category: "Trends",
  },
];

const EnhancedFAQ = () => {
  // State variables for search term, selected topic, and category filters.
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedTopic, setSelectedTopic] = useState("All");
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [openQuestions, setOpenQuestions] = useState([]);

  // Extract unique topics and categories for filter dropdowns.
  const topics = ["All", ...Array.from(new Set(faqs.map(faq => faq.topic)))];
  const categories = ["All", ...Array.from(new Set(faqs.map(faq => faq.category)))];

  // Toggle answer display for a given FAQ.
  const handleToggle = (id) => {
    if (openQuestions.includes(id)) {
      setOpenQuestions(openQuestions.filter(qid => qid !== id));
    } else {
      setOpenQuestions([...openQuestions, id]);
    }
  };

  // Filter FAQs based on search term, topic, and category.
  const filteredFaqs = faqs.filter(faq => {
    const matchesSearch = faq.question.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesTopic = selectedTopic === "All" || faq.topic === selectedTopic;
    const matchesCategory = selectedCategory === "All" || faq.category === selectedCategory;
    return matchesSearch && matchesTopic && matchesCategory;
  });

  return (
    <div className="p-4 md:p-8 bg-gray-50 rounded-lg shadow-md">
      <h2 className="text-2xl font-bold text-gray-800 mb-4">
        Frequently Asked Questions
      </h2>
      {/* Filter Section */}
      <div className="mb-4 flex flex-col md:flex-row md:items-center gap-4">
        <input
          type="text"
          placeholder="Search questions..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="flex-1 px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
        <select
          value={selectedTopic}
          onChange={(e) => setSelectedTopic(e.target.value)}
          className="px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          {topics.map((topic, index) => (
            <option key={index} value={topic}>
              {topic}
            </option>
          ))}
        </select>
        <select
          value={selectedCategory}
          onChange={(e) => setSelectedCategory(e.target.value)}
          className="px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          {categories.map((cat, index) => (
            <option key={index} value={cat}>
              {cat}
            </option>
          ))}
        </select>
      </div>
      {/* FAQ List */}
      <div>
        {filteredFaqs.length > 0 ? (
          filteredFaqs.map((faq) => (
            <div key={faq.id} className="mb-4">
              <button
                onClick={() => handleToggle(faq.id)}
                className="w-full text-left px-4 py-2 bg-white border border-gray-200 rounded-md hover:bg-gray-100 focus:outline-none"
              >
                <div className="flex justify-between items-center">
                  <span className="font-semibold">{faq.question}</span>
                  <span className="text-gray-500">
                    {openQuestions.includes(faq.id) ? '-' : '+'}
                  </span>
                </div>
                <div className="mt-1 text-xs text-gray-500">
                  <span>Topic: {faq.topic}</span> | <span>Category: {faq.category}</span>
                </div>
              </button>
              {openQuestions.includes(faq.id) && (
                <div className="mt-2 px-4 py-2 bg-gray-100 border border-gray-200 rounded-md">
                  <p className="text-gray-700">{faq.answer}</p>
                </div>
              )}
            </div>
          ))
        ) : (
          <p className="text-gray-600">No questions match your filters.</p>
        )}
      </div>
      {/* Additional sections can be added below */}
      {/* Example: <AnotherSectionComponent /> */}
    </div>
  );
};

export default EnhancedFAQ;
